import { render } from "./PokemonCard.vue?vue&type=template&id=4f1d419c&scoped=true"
import script from "./PokemonCard.vue?vue&type=script&lang=ts"
export * from "./PokemonCard.vue?vue&type=script&lang=ts"

import "./PokemonCard.vue?vue&type=style&index=0&id=4f1d419c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f1d419c"

export default script